/**
 * @file Web Gallery Waldograms related constants.
 */

/**
 * @enum WALDOGRAM_PRINT_TYPE
 * @type {{ONSITE: string, OFFSITE: string}}
 */
const WALDOGRAM_PRINT_TYPE = {
  ONSITE: 'ONSITE',
  OFFSITE: 'OFFSITE',
};

/**
 * Waldogram text caption allowances configuration enum.
 *
 * @enum WALDOGRAM_TEXT_CONFIGS
 * @type {{}}
 */
const WALDOGRAM_TEXT_CONFIGS = {
  [WALDOGRAM_PRINT_TYPE.ONSITE]: {
    rows: 13,
    charsPerRow: 45,
  },
  [WALDOGRAM_PRINT_TYPE.OFFSITE]: {
    rows: 13,
    charsPerRow: 45,
  },
};

export { WALDOGRAM_PRINT_TYPE, WALDOGRAM_TEXT_CONFIGS };
